module.exports = __webpack_public_path__ + "images/emoji/beers.0225045e6458f3ae7ddc.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/beers.png
// module id = nrIN
// module chunks = 1